<template>
  <div class="container col-12">
    <label>Viáticos</label>
    <div class="card container-fluid">
      <div class="card-body">
        <template>
          <div class="row">
            <div class="col-12 form-group form-group-sm">
              <label
                class="form-check-label d-flex align-items-center"
                style="cursor: pointer"
              >
                <input
                  type="checkbox"
                  v-model="viaticosCliente.activo"
                  @change="emitChange()"
                  class="form-check-inline mr-2"
                  style="zoom: 1.2; cursor: pointer"
                />
                Agregar viaticos al cliente
              </label>
            </div>

            <template v-if="viaticosCliente.activo">
              <div class="card container-fluid">
                <div class="card-body">
                  <template v-if="viaticosCliente.activo">
                    <div class="col-12 form-group form-group-sm">
                      <label
                        class="form-check-label d-flex align-items-center"
                        style="cursor: pointer"
                      >
                        <input
                          type="checkbox"
                          v-model="viaticosCliente.combustible.activo"
                          @change="emitChange()"
                          class="form-check-inline mr-2"
                          style="zoom: 1.2; cursor: pointer"
                        />
                        Combustible
                      </label>
                    </div>

                    <template v-if="viaticosCliente.combustible.activo">
                      <div class="card container-fluid">
                        <div class="card-body">
                          <div class="row">
                            <div
                              class="col-12 col-md-6 form-group form-group-sm"
                            >
                              <label for="clienteCombustibleKm" class="label"
                                >Kilómetros</label
                              >
                              <input
                                id="clienteCombustibleKm"
                                type="text"
                                v-model.number="
                                  viaticosCliente.combustible.kilometros
                                "
                                v-select-on-focus
                                class="form-control form-control-sm"
                                placeholder="Ingrese kilómetros"
                                @input="calcularMontoViaticosCliente"
                              />
                              <div
                                v-if="
                                  viaticosCliente.combustible.montoCalculado > 0
                                "
                                class="mt-2 text-muted small"
                              >
                                <div v-if="precioCombustible > 0" class="mb-2">
                                  <small class="text-info">
                                    <i class="fas fa-info-circle"></i>
                                    Precio del combustible:
                                    {{ formatMoney(precioCombustible) }} por
                                    litro
                                  </small>
                                  <small
                                    class="text-info"
                                    v-if="
                                      viaticosCliente.combustible
                                        .desgloseCalculo
                                    "
                                  >
                                    {{
                                      viaticosCliente.combustible
                                        .desgloseCalculo
                                    }}
                                  </small>
                                </div>
                                <div class="font-weight-bold text-success">
                                  Total a pagar:
                                  {{
                                    formatMoney(
                                      viaticosCliente.combustible
                                        .montoCalculado,
                                    )
                                  }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-12 col-md-6 form-group form-group-sm"
                            >
                              <label for="clienteCombustibleDesc" class="label"
                                >Descripción</label
                              >
                              <input
                                type="text"
                                id="clienteCombustibleDesc"
                                v-model="
                                  viaticosCliente.combustible.descripcion
                                "
                                @input="emitChange()"
                                class="form-control form-control-sm text-center"
                                rows="2"
                                placeholder="Ingrese descripción"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>

                  <template v-if="viaticosCliente.activo">
                    <div class="col-12 form-group form-group-sm">
                      <label
                        class="form-check-label d-flex align-items-center"
                        style="cursor: pointer"
                      >
                        <input
                          type="checkbox"
                          v-model="viaticosCliente.viaticoAdicional.activo"
                          @change="emitChange()"
                          class="form-check-inline mr-2"
                          style="zoom: 1.2; cursor: pointer"
                        />
                        Viático adicional
                      </label>
                    </div>
                    <template v-if="viaticosCliente.viaticoAdicional.activo">
                      <div class="card container-fluid">
                        <div class="card-body">
                          <div class="row">
                            <div
                              class="col-12 col-md-6 form-group form-group-sm"
                            >
                              <label for="clienteAdicionalMonto" class="label"
                                >Monto</label
                              >
                              <input
                                id="clienteAdicionalMonto"
                                type="text"
                                v-model.number="
                                  viaticosCliente.viaticoAdicional.monto
                                "
                                @input="emitChange()"
                                v-select-on-focus
                                class="form-control form-control-sm"
                                placeholder="Ingrese monto"
                              />
                            </div>
                            <div
                              class="col-12 col-md-6 form-group form-group-sm"
                            >
                              <label for="clienteAdicionalDesc" class="label"
                                >Descripción</label
                              >
                              <input
                                type="text"
                                id="clienteAdicionalDesc"
                                v-model="
                                  viaticosCliente.viaticoAdicional.descripcion
                                "
                                @input="emitChange()"
                                class="form-control form-control-sm text-center"
                                rows="2"
                                placeholder="Ingrese descripción"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </template>

        <template>
          <div class="row">
            <div class="col-12 form-group form-group-sm">
              <label
                class="form-check-label d-flex align-items-center"
                style="cursor: pointer"
              >
                <input
                  type="checkbox"
                  v-model="viaticosInstalador.activo"
                  @change="emitChange()"
                  class="form-check-inline mr-2"
                  style="zoom: 1.2; cursor: pointer"
                />
                Viaticos para el instalador
              </label>
            </div>

            <template v-if="viaticosInstalador.activo">
              <div class="container-fluid card">
                <div class="card-body">
                  <template v-if="viaticosInstalador.activo">
                    <div class="col-12 form-group form-group-sm">
                      <label
                        class="form-check-label d-flex align-items-center"
                        style="cursor: pointer"
                      >
                        <input
                          type="checkbox"
                          v-model="viaticosInstalador.combustible.activo"
                          @change="emitChange()"
                          class="form-check-inline mr-2"
                          style="zoom: 1.2; cursor: pointer"
                        />
                        Combustible
                      </label>
                    </div>

                    <template v-if="viaticosInstalador.combustible.activo">
                      <div class="card container-fluid">
                        <div class="card-body">
                          <div class="row">
                            <div
                              class="col-12 col-md-6 form-group form-group-sm"
                            >
                              <label for="instaladorCombustibleKm" class="label"
                                >Kilómetros</label
                              >
                              <input
                                id="instaladorCombustibleKm"
                                type="text"
                                v-model.number="
                                  viaticosInstalador.combustible.kilometros
                                "
                                v-select-on-focus
                                class="form-control form-control-sm"
                                placeholder="Ingrese kilómetros"
                                @input="calcularMontoViaticosInstalador"
                              />
                              <div
                                v-if="
                                  viaticosInstalador.combustible
                                    .montoCalculado > 0
                                "
                                class="mt-2 text-muted small"
                              >
                                <div v-if="precioCombustible > 0" class="mb-2">
                                  <small class="text-info">
                                    <i class="fas fa-info-circle"></i>
                                    Precio del combustible:
                                    {{ formatMoney(precioCombustible) }} por
                                    litro
                                  </small>
                                  <small
                                    class="text-info"
                                    v-if="
                                      viaticosCliente.combustible
                                        .desgloseCalculo
                                    "
                                  >
                                    {{
                                      viaticosCliente.combustible
                                        .desgloseCalculo
                                    }}
                                  </small>
                                </div>
                                <div class="font-weight-bold text-success">
                                  Total a pagar:
                                  {{
                                    formatMoney(
                                      viaticosInstalador.combustible
                                        .montoCalculado,
                                    )
                                  }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-12 col-md-6 form-group form-group-sm"
                            >
                              <label
                                for="instaladorCombustibleDesc"
                                class="label"
                                >Descripción</label
                              >
                              <input
                                type="text"
                                id="instaladorCombustibleDesc"
                                v-model="
                                  viaticosInstalador.combustible.descripcion
                                "
                                @input="emitChange()"
                                class="form-control form-control-sm text-center"
                                rows="2"
                                placeholder="Ingrese descripción"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>

                  <template v-if="viaticosInstalador.activo">
                    <div class="col-12 form-group form-group-sm">
                      <label
                        class="form-check-label d-flex align-items-center"
                        style="cursor: pointer"
                      >
                        <input
                          type="checkbox"
                          v-model="viaticosInstalador.viaticoAdicional.activo"
                          @change="emitChange()"
                          class="form-check-inline mr-2"
                          style="zoom: 1.2; cursor: pointer"
                        />
                        Viático adicional
                      </label>
                    </div>
                    <template v-if="viaticosInstalador.viaticoAdicional.activo">
                      <div class="card container-fluid">
                        <div class="card-body">
                          <div class="row">
                            <div
                              class="col-12 col-md-6 form-group form-group-sm"
                            >
                              <label
                                for="instaladorAdicionalMonto"
                                class="label"
                                >Monto</label
                              >
                              <input
                                id="instaladorAdicionalMonto"
                                type="text"
                                v-model.number="
                                  viaticosInstalador.viaticoAdicional.monto
                                "
                                @input="emitChange()"
                                v-select-on-focus
                                class="form-control form-control-sm"
                                placeholder="Ingrese monto"
                              />
                            </div>
                            <div
                              class="col-12 col-md-6 form-group form-group-sm"
                            >
                              <label for="instaladorAdicionalDesc" class="label"
                                >Descripción</label
                              >
                              <input
                                type="text"
                                id="instaladorAdicionalDesc"
                                v-model="
                                  viaticosInstalador.viaticoAdicional
                                    .descripcion
                                "
                                @input="emitChange()"
                                class="form-control form-control-sm text-center"
                                rows="2"
                                placeholder="Ingrese descripción"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ViaticosForm",
  props: {
    value: {
      type: Object,
      default: () => ({
        viaticosCliente: {
          activo: false,
          combustible: { activo: false, kilometros: 0, descripcion: "" },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
        viaticosInstalador: {
          activo: false,
          combustible: { activo: false, kilometros: 0, descripcion: "" },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
      }),
    },
  },
  data() {
    return {
      viaticosData: {
        viaticosCliente: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
        viaticosInstalador: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
      },
      precioCombustible: 0,
    };
  },
  computed: {
    viaticosCliente: {
      get() {
        return this.viaticosData.viaticosCliente;
      },
      set(value) {
        this.viaticosData.viaticosCliente = value;
        this.emitChange();
      },
    },
    viaticosInstalador: {
      get() {
        return this.viaticosData.viaticosInstalador;
      },
      set(value) {
        this.viaticosData.viaticosInstalador = value;
        this.emitChange();
      },
    },
  },
  mounted() {
    if (this.value) {
      this.viaticosData = JSON.parse(JSON.stringify(this.value));
    }
  },
  methods: {
    async calcularMontoViaticos(kilometros) {
      if (!kilometros || kilometros <= 0) {
        return { monto: 0, desglose: "" };
      }

      try {
        const response = await axios.post("/execute", {
          method: "CLI.CalcularMontoViaticosPorKm",
          parameters: [{ name: "kilometros", value: kilometros }],
        });

        if (
          response.data.ok &&
          response.data.result &&
          response.data.result.length > 0
        ) {
          const resultado = response.data.result[0][0];
          const monto = resultado.monto_total || 0;
          const desglose = resultado.desglose_calculo || "";
          const precioCombustible = resultado.precio_combustible || 0;

          this.precioCombustible = precioCombustible;

          return { monto, desglose, precioCombustible };
        } else {
          this.$msgBoxOk(
            "No se pudo obtener el cálculo de viáticos desde el servidor.",
          );
        }
      } catch (error) {
        console.error("Error al calcular monto de viáticos:", error);
      }
    },

    async calcularMontoViaticosCliente() {
      const kilometros = this.viaticosCliente.combustible.kilometros;
      const resultado = await this.calcularMontoViaticos(kilometros);

      this.viaticosCliente.combustible.montoCalculado = resultado.monto;
      this.viaticosCliente.combustible.desgloseCalculo = resultado.desglose;

      // Sincronizar con instalador si ambos están activos
      if (this.viaticosInstalador.combustible.activo) {
        this.viaticosInstalador.combustible.kilometros = kilometros;
        this.viaticosInstalador.combustible.montoCalculado = resultado.monto;
        this.viaticosInstalador.combustible.desgloseCalculo =
          resultado.desglose;
      }

      this.emitChange();
    },

    async calcularMontoViaticosInstalador() {
      const kilometros = this.viaticosInstalador.combustible.kilometros;
      const resultado = await this.calcularMontoViaticos(kilometros);

      this.viaticosInstalador.combustible.montoCalculado = resultado.monto;
      this.viaticosInstalador.combustible.desgloseCalculo = resultado.desglose;

      if (this.viaticosCliente.combustible.activo) {
        this.viaticosCliente.combustible.kilometros = kilometros;
        this.viaticosCliente.combustible.montoCalculado = resultado.monto;
        this.viaticosCliente.combustible.desgloseCalculo = resultado.desglose;
      }

      this.emitChange();
    },

    formatMoney(value) {
      if (!value || value === 0) return "$ 0,00";

      const numero = parseFloat(value)
        .toFixed(2)
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return "$ " + numero;
    },

    sincronizarKilometros() {
      if (
        this.viaticosCliente.combustible.activo &&
        this.viaticosInstalador.combustible.activo
      ) {
        const clienteKm = this.viaticosCliente.combustible.kilometros;
        const instaladorKm = this.viaticosInstalador.combustible.kilometros;

        if (clienteKm && clienteKm !== instaladorKm) {
          this.viaticosInstalador.combustible.kilometros = clienteKm;
          this.calcularMontoViaticosInstalador();
        } else if (instaladorKm && instaladorKm !== clienteKm) {
          this.viaticosCliente.combustible.kilometros = instaladorKm;
          this.calcularMontoViaticosCliente();
        }
      }
      this.emitChange();
    },
    emitChange() {
      this.$emit("input", this.viaticosData);
      this.$emit("change", this.viaticosData);
    },
    validateForm() {
      const errors = [];

      if (this.viaticosCliente.activo) {
        if (
          !this.viaticosCliente.combustible.activo &&
          !this.viaticosCliente.viaticoAdicional.activo
        ) {
          errors.push(
            "Por favor, seleccione al menos un tipo de viático para el cliente (combustible o viático adicional)",
          );
        }

        if (this.viaticosCliente.combustible.activo) {
          // Validar kilómetros del cliente
          if (
            isNaN(this.viaticosCliente.combustible.kilometros) ||
            !this.viaticosCliente.combustible.kilometros
          ) {
            errors.push(
              "Por favor, ingrese solo números para los kilómetros del combustible del cliente",
            );
          } else if (this.viaticosCliente.combustible.kilometros === 0) {
            errors.push(
              "Por favor, ingrese un número mayor a 0 para los kilómetros del combustible del cliente",
            );
          }

          if (
            !this.viaticosCliente.combustible.descripcion ||
            this.viaticosCliente.combustible.descripcion.trim() === ""
          ) {
            errors.push(
              "Por favor, ingrese la descripción del combustible para el cliente",
            );
          }
        }

        if (this.viaticosCliente.viaticoAdicional.activo) {
          // Validar monto adicional del cliente
          if (
            isNaN(this.viaticosCliente.viaticoAdicional.monto) ||
            !this.viaticosCliente.viaticoAdicional.monto
          ) {
            errors.push(
              "Por favor, ingrese solo números para el monto del viático adicional del cliente",
            );
          } else if (this.viaticosCliente.viaticoAdicional.monto === 0) {
            errors.push(
              "Por favor, ingrese un número mayor a 0 para el monto del viático adicional del cliente",
            );
          }

          if (
            !this.viaticosCliente.viaticoAdicional.descripcion ||
            this.viaticosCliente.viaticoAdicional.descripcion.trim() === ""
          ) {
            errors.push(
              "Por favor, ingrese la descripción del viático adicional para el cliente",
            );
          }
        }
      }

      if (this.viaticosInstalador.activo) {
        if (
          !this.viaticosInstalador.combustible.activo &&
          !this.viaticosInstalador.viaticoAdicional.activo
        ) {
          errors.push(
            "Por favor, seleccione al menos un tipo de viático para el instalador (combustible o viático adicional)",
          );
        }

        if (this.viaticosInstalador.combustible.activo) {
          // Validar kilómetros del instalador
          if (
            isNaN(this.viaticosInstalador.combustible.kilometros) ||
            !this.viaticosInstalador.combustible.kilometros
          ) {
            errors.push(
              "Por favor, ingrese solo números para los kilómetros del combustible del instalador",
            );
          } else if (this.viaticosInstalador.combustible.kilometros === 0) {
            errors.push(
              "Por favor, ingrese un número mayor a 0 para los kilómetros del combustible del instalador",
            );
          }

          if (
            !this.viaticosInstalador.combustible.descripcion ||
            this.viaticosInstalador.combustible.descripcion.trim() === ""
          ) {
            errors.push(
              "Por favor, ingrese la descripción del combustible para el instalador",
            );
          }
        }

        if (this.viaticosInstalador.viaticoAdicional.activo) {
          // Validar monto adicional del instalador
          if (
            isNaN(this.viaticosInstalador.viaticoAdicional.monto) ||
            !this.viaticosInstalador.viaticoAdicional.monto
          ) {
            errors.push(
              "Por favor, ingrese solo números para el monto del viático adicional del instalador",
            );
          } else if (this.viaticosInstalador.viaticoAdicional.monto === 0) {
            errors.push(
              "Por favor, ingrese un número mayor a 0 para el monto del viático adicional del instalador",
            );
          }

          if (
            !this.viaticosInstalador.viaticoAdicional.descripcion ||
            this.viaticosInstalador.viaticoAdicional.descripcion.trim() === ""
          ) {
            errors.push(
              "Por favor, ingrese la descripción del viático adicional para el instalador",
            );
          }
        }
      }

      return errors;
    },
    getFormattedViaticos() {
      return {
        viaticosCliente: {
          activo: this.viaticosCliente.activo,
          combustible: {
            activo: this.viaticosCliente.combustible.activo,
            kilometros:
              Number(this.viaticosCliente.combustible.kilometros) || 0,
            montoCalculado:
              Number(this.viaticosCliente.combustible.montoCalculado) || 0,
            descripcion: this.viaticosCliente.combustible.descripcion || "",
          },
          viaticoAdicional: {
            activo: this.viaticosCliente.viaticoAdicional.activo,
            monto: Number(this.viaticosCliente.viaticoAdicional.monto) || 0,
            descripcion:
              this.viaticosCliente.viaticoAdicional.descripcion || "",
          },
        },
        viaticosInstalador: {
          activo: this.viaticosInstalador.activo,
          combustible: {
            activo: this.viaticosInstalador.combustible.activo,
            kilometros:
              Number(this.viaticosInstalador.combustible.kilometros) || 0,
            montoCalculado:
              Number(this.viaticosInstalador.combustible.montoCalculado) || 0,
            descripcion: this.viaticosInstalador.combustible.descripcion || "",
          },
          viaticoAdicional: {
            activo: this.viaticosInstalador.viaticoAdicional.activo,
            monto: Number(this.viaticosInstalador.viaticoAdicional.monto) || 0,
            descripcion:
              this.viaticosInstalador.viaticoAdicional.descripcion || "",
          },
        },
      };
    },
    resetForm() {
      this.viaticosData = {
        viaticosCliente: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
        viaticosInstalador: {
          activo: false,
          combustible: {
            activo: false,
            kilometros: 0,
            montoCalculado: 0,
            desgloseCalculo: "",
            descripcion: "",
          },
          viaticoAdicional: { activo: false, monto: 0, descripcion: "" },
        },
      };
      this.emitChange();
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.viaticosData = JSON.parse(JSON.stringify(newValue));
        }
      },
      deep: true,
    },
    "viaticosCliente.combustible.activo"(newValue) {
      if (newValue && this.viaticosInstalador.combustible.activo) {
        this.sincronizarKilometros();
      }
      if (!newValue) {
        this.viaticosCliente.combustible.kilometros = 0;
        this.viaticosCliente.combustible.montoCalculado = 0;
        this.viaticosCliente.combustible.desgloseCalculo = "";
        this.viaticosCliente.combustible.descripcion = "";
        this.emitChange();
      }
    },
    "viaticosInstalador.combustible.activo"(newValue) {
      if (newValue && this.viaticosCliente.combustible.activo) {
        this.sincronizarKilometros();
      }
      if (!newValue) {
        this.viaticosInstalador.combustible.kilometros = 0;
        this.viaticosInstalador.combustible.montoCalculado = 0;
        this.viaticosInstalador.combustible.desgloseCalculo = "";
        this.viaticosInstalador.combustible.descripcion = "";
        this.emitChange();
      }
    },
    "viaticosCliente.viaticoAdicional.activo"(newValue) {
      if (!newValue) {
        this.viaticosCliente.viaticoAdicional.monto = 0;
        this.viaticosCliente.viaticoAdicional.descripcion = "";
        this.emitChange();
      }
    },
    "viaticosInstalador.viaticoAdicional.activo"(newValue) {
      if (!newValue) {
        this.viaticosInstalador.viaticoAdicional.monto = 0;
        this.viaticosInstalador.viaticoAdicional.descripcion = "";
        this.emitChange();
      }
    },
    "viaticosCliente.activo"(newValue) {
      if (!newValue) {
        this.viaticosCliente.combustible.activo = false;
        this.viaticosCliente.combustible.kilometros = 0;
        this.viaticosCliente.combustible.montoCalculado = 0;
        this.viaticosCliente.combustible.desgloseCalculo = "";
        this.viaticosCliente.combustible.descripcion = "";
        this.viaticosCliente.viaticoAdicional.activo = false;
        this.viaticosCliente.viaticoAdicional.monto = 0;
        this.viaticosCliente.viaticoAdicional.descripcion = "";
        this.emitChange();
      }
    },
    "viaticosInstalador.activo"(newValue) {
      if (!newValue) {
        this.viaticosInstalador.combustible.activo = false;
        this.viaticosInstalador.combustible.kilometros = 0;
        this.viaticosInstalador.combustible.montoCalculado = 0;
        this.viaticosInstalador.combustible.desgloseCalculo = "";
        this.viaticosInstalador.combustible.descripcion = "";
        this.viaticosInstalador.viaticoAdicional.activo = false;
        this.viaticosInstalador.viaticoAdicional.monto = 0;
        this.viaticosInstalador.viaticoAdicional.descripcion = "";
        this.emitChange();
      }
    },
  },
};
</script>

<style scoped>
.form-check-label {
  font-weight: 500;
}

.label {
  font-weight: 500;
  margin-bottom: 5px;
}

.form-control-sm {
  font-size: 0.875rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mr-2 {
  margin-right: 0.5rem;
}
</style>
